export const FONT_TYPES = [
    'jfproj',
    'ttf',
    'vlw',
    'fnt',
    'woff',
    'fot',
    'pfb',
    'sfd',
    'pfa',
    'otf',
    'woff2',
    'odttf',
    'pf2',
    'pmt',
    'ttc',
    'etx'
];
